/**
 * @generated SignedSource<<fabcb9f9327ef972f483d777eec0fc59>>
 * @relayHash dedb081c5add026f20c05d4334cb1d2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea7c102ed16785e262a59355d1a562d8b481ab05fa5605be3c7ce4e127d3d095

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraContainerNavigationQueryInput = {
  projectKeyQuery?: JiraContainerNavigationByProjectKeyQueryInput | null | undefined;
  scopeId?: string | null | undefined;
};
export type JiraContainerNavigationByProjectKeyQueryInput = {
  cloudId: string;
  projectKey: string;
};
export type tabs_jwmNavigationItemsQuery$variables = {
  cloudId: string;
  containerNavigationInput: JiraContainerNavigationQueryInput;
  first: number;
  projectIdOrKey: string;
  useContainerNavigation: boolean;
};
export type tabs_jwmNavigationItemsQuery$data = {
  readonly jira: {
    readonly containerNavigation?: {
      readonly __typename: "QueryError";
      readonly extensions?: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly id?: string;
      readonly message?: string | null | undefined;
      readonly navigationItems?: {
        readonly edges: ReadonlyArray<{
          readonly __typename: "JiraNavigationItemEdge";
        } | null | undefined> | null | undefined;
        readonly errors: ReadonlyArray<{
          readonly extensions: ReadonlyArray<{
            readonly statusCode: number | null | undefined;
          }> | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabList_TabList_tabsFragment">;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ui_addTab_business_containerFragment" | "ui_addTab_containerFragment" | "ui_navigationKitTabList_TabList_containerFragment">;
    } | null | undefined;
    readonly navigationItems?: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraNavigationItemEdge";
      } | null | undefined> | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly extensions: ReadonlyArray<{
          readonly statusCode: number | null | undefined;
        }> | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabList_TabList_tabsFragment">;
    };
  };
};
export type tabs_jwmNavigationItemsQuery = {
  response: tabs_jwmNavigationItemsQuery$data;
  variables: tabs_jwmNavigationItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerNavigationInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useContainerNavigation"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "projectIdOrKey",
  "variableName": "projectIdOrKey"
},
v7 = {
  "kind": "FragmentSpread",
  "name": "ui_navigationKitTabList_TabList_tabsFragment"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v10 = [
  (v8/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "message"
},
v12 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v13 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v12/*: any*/)
  ]
},
v14 = {
  "concreteType": "QueryError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v13/*: any*/)
  ]
},
v15 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v16 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "containerNavigationInput"
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v19 = [
  (v18/*: any*/)
],
v20 = [
  (v5/*: any*/),
  (v18/*: any*/),
  (v6/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "label"
},
v22 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v23 = {
  "kind": "ScalarField",
  "name": "url"
},
v24 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v25 = {
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v17/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isDefault"
    },
    {
      "kind": "ScalarField",
      "name": "typeKey"
    },
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v21/*: any*/),
    {
      "kind": "ScalarField",
      "name": "canRemove"
    },
    {
      "kind": "ScalarField",
      "name": "canSetAsDefault"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraAppSection",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            (v21/*: any*/),
            {
              "concreteType": "JiraAppNavigationItemNestedLink",
              "kind": "LinkedField",
              "name": "links",
              "plural": true,
              "selections": [
                (v21/*: any*/),
                (v22/*: any*/),
                (v23/*: any*/),
                (v24/*: any*/)
              ]
            }
          ]
        },
        (v23/*: any*/),
        (v22/*: any*/),
        (v24/*: any*/),
        {
          "kind": "ScalarField",
          "name": "appType"
        },
        {
          "kind": "ScalarField",
          "name": "envLabel"
        }
      ],
      "type": "JiraAppNavigationItem"
    }
  ]
},
v26 = [
  (v11/*: any*/),
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v8/*: any*/),
      (v12/*: any*/)
    ]
  }
],
v27 = {
  "concreteType": "QueryError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": (v26/*: any*/)
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "tabs_jwmNavigationItemsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "condition": "useContainerNavigation",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": "navigationItems",
                    "args": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "__tabs_jiraNavigation__navigationItems_connection",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v10/*: any*/)
                          }
                        ]
                      },
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.navigationItems"
                }
              ]
            },
            {
              "condition": "useContainerNavigation",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": (v16/*: any*/),
                  "kind": "LinkedField",
                  "name": "containerNavigation",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ui_navigationKitTabList_TabList_containerFragment"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "ui_addTab_business_containerFragment"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "ui_addTab_containerFragment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        {
                          "args": (v19/*: any*/),
                          "concreteType": "JiraNavigationItemConnection",
                          "kind": "LinkedField",
                          "name": "navigationItems",
                          "plural": false,
                          "selections": [
                            (v7/*: any*/),
                            {
                              "concreteType": "JiraNavigationItemEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": (v10/*: any*/)
                            },
                            (v14/*: any*/)
                          ]
                        }
                      ],
                      "type": "JiraContainerNavigation"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v8/*: any*/),
                        (v11/*: any*/),
                        (v13/*: any*/)
                      ],
                      "type": "QueryError"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "tabs_jwmNavigationItemsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "useContainerNavigation",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "navigationItems",
                "args": (v20/*: any*/),
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "jwmSavedViewsByProject",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNavigationItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  (v27/*: any*/),
                  (v15/*: any*/)
                ]
              },
              {
                "alias": "navigationItems",
                "args": (v20/*: any*/),
                "filters": [
                  "cloudId",
                  "projectIdOrKey"
                ],
                "handle": "connection",
                "key": "tabs_jiraNavigation__navigationItems",
                "kind": "LinkedHandle",
                "name": "jwmSavedViewsByProject"
              }
            ]
          },
          {
            "condition": "useContainerNavigation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v16/*: any*/),
                "kind": "LinkedField",
                "name": "containerNavigation",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraContainerNavigationResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      {
                        "args": (v19/*: any*/),
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "navigationItems",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraNavigationItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v25/*: any*/),
                              (v8/*: any*/)
                            ]
                          },
                          (v27/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraContainerNavigation"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v26/*: any*/),
                    "type": "QueryError"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ea7c102ed16785e262a59355d1a562d8b481ab05fa5605be3c7ce4e127d3d095",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "navigationItems"
          ]
        }
      ]
    },
    "name": "tabs_jwmNavigationItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "10f8f0b68814ca46410cece242b77c9a";

export default node;
